export default {
  lang: 'Spanish',
  homeScreen: {
    title: '', // Específico del producto
    stayConnected: 'Mantente Conectado',
    comingSoon: 'Próximamente',
    messages: 'Mensajes',
    subtitle: '',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Algo salió mal. Por favor, inténtalo de nuevo más tarde.',
    },
    programStatus: {
      title: 'Mi Estado',
      loading: 'Cargando…',
      yourRep: 'Tu Rep',
      myProfile: 'Mi Perfil',
      favorites: 'Favoritos',
      registeredOn: 'Registrado el:',
      graduatedOn: 'Graduado el:',
      totalBadgesEarned: 'Total de Insignias Obtenidas:',
      lastBookingLogged: 'Última Reserva Registrada:',
      currentTier: 'Nivel Actual',
      lastBadgeEarned: 'Última Insignia Obtenida:',
      currentFocus: 'Enfoque Actual:',
      changeProfilePicture: 'Cambiar Foto de Perfil',
    },
    todaysfocus: {
      title: 'Enfoque de Hoy',
      empty: 'No hay elementos de enfoque para hoy',
      loading: 'Cargando…',
      error: 'Algo salió mal',
      slideNavAria: 'Navegación de diapositivas',
      slideAria: 'Diapositiva',
      carouselAria: 'Enfoque de hoy',
    },
    welcome: '¡Bienvenido!',
    welcomeBack: '¡Bienvenido de nuevo, {firstName}!',
    notifications: {
      loading: 'Cargando…',
      empty: 'No hay notificaciones',
    },
    achievements: {
      title: 'Recompensas y Concursos',
      loading: 'Cargando…',
      lastBooking: 'Última Entrada Enviada',
      currentTier: 'Nivel Actual',
      contestEntries: 'Total de Participaciones en Concursos',
      nightsBooked: 'Noches Reservadas',
      totalRevenue: 'Ingresos Totales Reportados',
      noBookingData: 'No hay datos de reservas disponibles.',
      notAvailable: 'N/D',
      fileUploadSuccess: 'El archivo se ha subido correctamente.',
      quickSubmit: {
        title: 'Envío rápido',
        uploading: 'Subiendo…',
        clear: 'Limpiar',
        submit: 'Enviar',
        submitSuccessSimulated: 'Reserva enviada correctamente',
      },
    },
  },
  notification: {
    newAndNow: '¡Nuevo y Ahora!',
    alert: 'Alerta',
    message: 'Mensaje',
    contest: 'Concurso',
    badge: 'Nueva Insignia',
    'content-update': 'Actualización de Contenido',
    events: 'Eventos',
    other: 'Notificación',
    welcome: 'Bienvenido',
  },
  loginScreen: {
    version2custom: {
      defaultAmbassador: {
        step2: 'Paso 1: Crear Una Cuenta',
        step3: 'Paso 2: Crear Tu Perfil',
      },
      houstonInsider: {
        hospitalityCheckboxLabel:
          'Actualmente, este programa está limitado a los empleados del sector hotelero que residen en Houston. Aunque esperamos ampliar los criterios de elegibilidad en el futuro, ten en cuenta que los participantes que no cumplan los requisitos actuales podrían ser excluidos del programa.',
      },
      app1857: {
        fields: {
          howDiscoveredKLA: '¿Cómo descubrió la Key Lime Academy?',
          tradeshowDetailLabel: '¿En qué feria o conferencia?',
          tradeshowDetailPlaceholder: 'Introduzca el nombre de la feria o conferencia',
          discoverVisitFloridaKeys: 'Sitio web de Visit Florida Keys',
          discoverSearchEngine: 'Motor de búsqueda (p. ej., Google, Yahoo)',
          discoverAiTool: 'Herramienta de IA/búsqueda (p. ej., ChatGPT, Perplexity)',
          discoverSocialMedia: 'Redes sociales (p. ej., Instagram, X, Facebook, LinkedIn)',
          discoverEmailNewsletter: 'Correo electrónico o boletín informativo',
          discoverWordOfMouth: 'Boca a boca',
          discoverTradeshowConference: 'Feria o conferencia (indíquenos cuál)',
          discoverOtherTravproAffiliate: 'Otros sitios afiliados a TravPRO',
        },
      },
      app1865: {
        fields: {
          topTravelType: '¿Cuál es el tipo de viaje más importante que vendes?',
          travelTypeAdventure: 'Aventura/Aventura Suave/Expedición',
          travelTypeAllInclusive: 'Todo Incluido',
          travelTypeBusinessMice: 'Negocios/MICE',
          travelTypeCultureExperiential: 'Cultura/Experiencial',
          travelTypeCruise: 'Crucero',
          travelTypeFamilyMultiGen: 'Familia/Multigeneracional',
          travelTypeRomance: 'Romance/Boda/Luna de Miel',
          travelTypeLuxury: 'Lujo',
          travelTypeRail: 'Tren',
          travelTypeTours: 'Tours',
          travelTypeWellness: 'Bienestar/Salud/Spa',
          travelTypeLgbtq: 'LGBTQ+',
        },
      },
      app1826: {
        fields: {
          optMarketing:
            'Mantente en contacto con el equipo de profesionales del sector turístico y los socios de este programa y recibe las últimas novedades.',
        },
      },
      app842: {
        fields: {
          segments: '¿Qué segmento(s) vende principalmente?',
          segmentLeisure: 'Ocio',
          segmentCorporate: 'Empresas',
          segmentGroup: 'Grupos',
        },
      },
    },
    version2: {
      homeTitle: 'Veamos si podemos encontrar un perfil existente para ti en nuestro sistema.',
      homeTitleSub:
        'Ingresa la dirección de correo electrónico que normalmente usas para iniciar sesión en programas de capacitación.',
      noAccount:
        'No se encontró cuenta ({email}), por favor intenta con otro correo electrónico o crea una cuenta ahora.',
      continueButton: 'Continuar',
      success: '¡Tu cuenta se actualizó exitosamente! Serás redirigido en breve a la página de inicio.',
      successNewAccount:
        'Para completar tu registro, recibirás un correo electrónico de confirmación para verificar tu cuenta.',
      loginButton: 'Iniciar Sesión',
      matchFound: 'Hemos encontrado una coincidencia, por favor ingresa tu contraseña para continuar.',
      magicLink: 'Iniciar sesión a través de un enlace en tu correo:',
      magicLinkButton: 'Solicitar Enlace Mágico',
      magicLinkTitle:
        'Recibe un enlace directo enviado a tu correo electrónico que te permitirá iniciar sesión instantáneamente.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor tómate un momento para completar toda la información a continuación ya que poblará tu perfil personal e información de contacto.',
      titleIndustry:
        'Por favor tómate un momento para completar toda la información a continuación ya que poblará tu perfil personal e información de contacto.',
      register: 'Crear una cuenta',
      agent: 'Asesor de Viajes',
      visitor: 'Visitante de la Industria',
      ambassador: 'Embajador',
      step1: 'Paso 1: Tipo de Usuario',
      step2: 'Paso 2: Crear Una Cuenta',
      step3: 'Paso 3: Crear Tu Perfil',
      marketingOptIn:
        '¿Estás seguro de que no te interesa mantenerte conectado al equipo comercial de viajes de este programa?',
      optIn: 'Sí, Estoy Interesado',
      optOut: 'No Estoy Interesado',
      step2Sub1: 'Cuéntanos Sobre Ti',
      step2Sub2: 'Cuéntanos Sobre Tu Negocio',
      step2Sub3: 'Cuéntenos sobre su empresa',
      privacyHead: 'PREFERENCIAS DE COMUNICACIÓN',
      privacySub:
        'Marca las casillas a continuación para asegurar que recibas comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de apoyo en ventas y networking comercial de viajes de TravPRO Mobile.',
      privacy: 'Protegemos tu privacidad y nunca vendemos, mal utilizamos o traicionamos tu confianza.',
      store: 'Descarga fácilmente este programa en tu tienda de aplicaciones:',
      powered: 'IMPULSADO POR',
      toastMessage: {
        forgotSuccess:
          '¡Te hemos enviado por correo electrónico el enlace para restablecer tu contraseña! Serás redirigido a la página de inicio de sesión en 10 segundos.',
        emailNotExisting: 'La dirección de correo electrónico que ingresaste no existe.',
        magicLinkMessage: 'Por favor espera, te estamos iniciando sesión ahora mismo.',
        magicLinkError:
          'No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkError1:
          'No pudimos encontrar un token válido, por favor inicia sesión o solicita un nuevo enlace mágico. Si este problema persiste, por favor contáctanos en: info@travpromobile.com.',
        magicLinkError2:
          'No pudimos encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Serás redirigido en 10 segundos.',
        magicLinkSuccess:
          'Revisa tu correo electrónico en {email}. Tiene un enlace mágico que te permitirá iniciar sesión.',
        magicLinkErrorWait: 'Por favor espera 5 minutos entre solicitudes de enlace mágico.',
        emailNotFoundError:
          'La dirección de correo electrónico que ingresaste no se puede encontrar en nuestros registros. Por favor verifica errores de escritura o crea una cuenta.',
      },
      errors: {
        zipCodeNotFound: 'Código postal no encontrado, inténtalo de nuevo',
        zipCodeOnlyNumbers: 'El código postal solo puede contener números',
        password: 'Por favor ingresa una contraseña',
        passwordNotMatching: 'Las contraseñas que ingresaste no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
        emailExists:
          'Esta dirección de correo electrónico ya existe o es inválida. Por favor intenta con otra dirección de correo electrónico o inicia sesión en tu cuenta.',
        fillInAllFields: 'Por favor completa todos los campos requeridos',
        fillInEmail: 'Por favor ingresa tu correo electrónico.',
        emailNotExisting: 'La dirección de correo electrónico que ingresaste no existe.',
      },
      fields: {
        forgotSubCopy: '¿Olvidaste tu contraseña y quieres cambiarla? ',
        forgotSubCopy2:
          '¿Quieres omitir completamente la contraseña? Te enviaremos un correo electrónico con un enlace mágico que te iniciará sesión automáticamente en el programa. ',
        city: 'Ciudad',
        companyName: 'Nombre de la Empresa',
        role: 'Tu Rol',
        description: '¿Cuál describe mejor el negocio de tu empresa?',
        country: 'País',
        password: 'Contraseña',
        passwordRegister: 'Elegir Contraseña (mínimo 8 caracteres)',
        passwordConfirm: 'Confirmar Contraseña',
        firstName: 'Nombre (Dado)',
        lastName: 'Apellido (Familia)',
        agency: 'El Nombre de Tu Agencia',
        employer: 'Nombre de la empresa',
        employerRole: '¿Cuál describe mejor su función?',
        employerYears: '¿Cuántos años lleva viviendo en la zona donde trabaja?',
        title: 'Tu Rol (Selecciona Uno)',
        company: 'Nombre de la Empresa',
        select: 'Selecciona una opción a continuación',
        state: 'Estado',
        province: 'Provincia/Región/Estado',
        zipCode: 'Código Postal',
        postalCode: 'Código Postal',
        affiliate: '¿Cuál es la afiliación PRINCIPAL de tu agencia?',
        hostAgency: '¿Tu Agencia Anfitriona?',
        ataCliaArc: '¿Cuál es su número ATA/CLIA/ARC?',
        executive: 'Ejecutivo',
        management: 'Gerencia',
        marketing: 'Marketing',
        sales: 'Ventas',
        coordinator: 'Coordinador',
        other: 'Otro',
        opt: 'Mantente conectado al equipo comercial de viajes de este programa y recibe actualizaciones.',
        optMarketing: 'Mantente conectado a TravPRO con respecto a programas y eventos similares.',
        retail: 'Tienda de Venta al Público',
        home: 'Agente desde Casa',
        independent: 'Contratista Independiente',
        host: 'Agencia Anfitriona',
        call: 'Centro de Llamadas o Agencia Basada en Web',
        describes: '¿Qué describe mejor a ti y al negocio de tu agencia? ',
        invalidEmail: 'Introduzca una dirección de correo electrónico válida',
        roleDMO: 'DMO',
        roleEventEmployee: 'Empleado de eventos',
        roleHotelEmployee: 'Empleado de hotel',
        roleRestaurantBar: 'Empleado de restaurante/bar',
        roleRetailService: 'Empleado de comercio minorista y servicios',
        roleTourActivity: 'Empleado de operador turístico y de actividades',
        roleTransportation: 'Empleado de transporte',
        roleOther: 'Otro',
        yearsJustArrived: 'Acaba de llegar (<6 meses)',
        years1to5: 'De 1 a 5 años',
        years5to10: 'De 5 a 10 años',
        years10Plus: 'Más de 10 años',
      },
    },
    title: 'Programa de Capacitación y Habilitación de Ventas para Profesionales de Viajes', // Específico del producto (texto TravPRO o texto ChannelPRO)
    welcome: {
      headerTop: 'Bienvenido a',
    },
    sellingPoints: {
      // Todos los puntos de venta pueden ser específicos del producto
      0: 'Aprende, Promociona y Vende Sobre la Marcha',
      1: 'Capacitación Multimedia en Todos los Dispositivos',
      2: 'Certificado de Finalización',
      3: 'Presentaciones de Ventas Listas para Usar',
      4: 'Materiales Promocionales de Alto Impacto',
      5: 'Consejos Internos y Promociones',
      6: 'Directorio de Productos en Tiempo Real',
      7: 'Noticias y Actualizaciones Oportunas',
    },
    emailPrompt:
      'Por favor ingresa tu dirección de correo electrónico y contraseña para confirmar que eres un profesional de viajes.', // Específico del producto (texto TravPRO o ChannelPRO)
    tAndC: {
      agree: 'Al continuar aceptas nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      what: '¿Qué tipo de viajes vendes?',
      what1: '¿Cuál es el tipo de viaje #1 que vendes?',
      what2: '¿Cuál es el tipo de viaje #2 que vendes?',
      what3: '¿Cuál es el tipo de viaje #3 que vendes?',
      agency: 'Agencia *',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      passwordConfirm: 'Confirma tu contraseña *',
      firstName: 'Nombre *',
      lastName: 'Apellido *',
      agencyName: 'Nombre de la Agencia *',
      city: 'Ciudad *',
      stateProvince: 'Estado / Provincia *',
      salutation: 'Saludo *',
      required: 'Requerido',
      invalidEmail: 'Dirección de correo electrónico inválida',
      complete: 'Paso 2: Completa tu perfil',
      tell: 'Cuéntanos Sobre Ti',
      title: 'Título Comercial *',
      host: 'Nombre de la Agencia Anfitriona',
      country: 'País / Región',
      select: 'Por favor selecciona una opción a continuación',
      header2: '¿Qué segmento(s) vendes principalmente?',
      step2: 'Describe Tu Negocio',
      leisure: 'Placer',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: '¿Cuál es Tu Afiliación Principal?',
      forgot:
        '¿Olvidaste tu contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    noAgent: {
      noAgentButton: 'No soy asesor',
      title: 'Gracias por tu interés en\n{clientName}', // Específico del producto
      messageWeb:
        'El contenido en este sitio es exclusivamente para profesionales de viajes.\nPara aprender más sobre {clientName}, por favor visita: ', // Específico del producto
      messageMobile:
        "Parte del contenido en esta aplicación es exclusivamente para profesionales de viajes, pero siéntete libre de navegar una vista previa de lo que esta aplicación tiene para ofrecer presionando 'Continuar'.", // Específico del producto
      continue: 'Continuar',
      visitWebsite: 'Visitar sitio web',
    },
    newUser: 'Usuario Nuevo',
    register: 'Registrarse',
    registered: 'Este correo electrónico ya está registrado',
    forgot: 'Restablecer Contraseña',
    header:
      'Por favor tómate un momento para completar toda la información a continuación, ya que esto es lo que poblará tu perfil e información de contacto.',
    step1: 'Paso 1: Completa tu dirección de correo electrónico y elige una contraseña.',
  },
  welcomeScreen: {
    helloUser: 'Hola {{name}}',
    hello: 'Hola,',
    fromAgency: 'de {{agency}}',
    notUser: '¿No eres {{name}}?',
    introOnline:
      '¡Entrénate inmediatamente en línea o precarga el contenido para que esté siempre disponible para uso sin conexión!',
    introOffline: '¡Ya tienes la última versión precargada. Comienza a entrenar o vender en cualquier momento y lugar!',
    startTraining: 'Comenzar a aprender',
    continueTraining: 'Continuar aprendiendo',
    graduated: '¡Felicitaciones!',
    downloader: {
      preload: 'Precargar',
      stop: 'detener',
      init: 'Inicializando...',
      lastUpdate: 'Última actualización: ',
    },
  },
  trainingScreens: {
    start: 'Comenzar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% Completado',
    unlock: 'Desbloquea este capítulo completando el capítulo de entrenamiento {number}.',
    unlockFoundation: 'Desbloquea este capítulo completando el capítulo de entrenamiento {number}.',
    unlockSpecialization: 'Desbloquea ganando tu certificado.',
    unlockPartners: 'Desbloquea ganando tu certificado.',
    unlockRetain: 'Desbloquea este capítulo completando los fundamentos en {name}.',
    unlockSubtitle: 'Desbloquea más capítulos completando capítulos de entrenamiento.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Has llegado al final',
    retainEnd:
      'Usa la barra superior para navegar en este capítulo o presiona el botón de atrás para regresar a la vista general.',
    watchListenRead: 'Mira, Escucha y Lee más',
    trouble:
      'Parece que tienes problemas, por favor vuelve a leer el contenido de la(s) página(s) anterior(es) e inténtalo de nuevo.',
    confirm: 'Confirma tu respuesta',
    choose: 'Por favor elige una respuesta',
    skip: 'Regresar >',
    viewAllTitle: 'Consejo de formación',
    viewAll:
      'Para pasar a la página siguiente, asegúrese de revisar todo el contenido de la página. Esto puede incluir ver todos los vídeos, hacer clic en los iconos para ver los materiales complementarios y responder correctamente a las preguntas. Esta información útil se ha proporcionado para mejorar su formación y garantizar que alcance el estatus PRO.',
    fillBlanks: 'Llena el/los espacio(s) en blanco:',
    next: 'Siguiente pregunta',
    retry: 'Inténtalo de Nuevo',
    fastTrackContinue: 'Continuar Fast Track',
    fastTrackMoveToFull: 'Cancelar Fast Track',
    fastTrackPrompt:
      '¿Ya se considera un experto en BVI? ¿Le gustaría intentar obtener su certificación por vía rápida? Un intento, 15 preguntas, nota de aprobación del 80 % (B).',
    grading: 'Tu calificación final es: {grade}',
  },
  nav: {
    home: 'Inicio',
    train: 'Entrenar',
    learn: 'Aprender',
    retain: 'Retener',
    directory: 'Directorio',
    showRoom: 'Aliados',
    showcases: 'Aliados',
    offers: 'Ofertas',
    promote: 'Promocionar',
    sell: 'Vender',
    info: 'Información',
    rewards: 'Recompensas',
    achievements: 'Logros',
    media: 'Media',
    favorites: 'Favoritos',
    contact: 'Conoce al Equipo',
    reportCard: 'Ver Diploma',
    accountSettings: 'Configuración de Cuenta',
    changeProfileImage: 'Cambiar imagen de perfil',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Entrenar',
    retain: 'Retener',
    subapps: 'Módulos de Microaprendizaje para Socios',
    subAppsFull: 'Compañeros de Ventas para Socios',
    maintrainings: 'Los Fundamentos',
    subtrainings: 'La Experiencia',
    fastTrack: 'Fast Track',
  },
  pageDescriptions: {
    train: 'Educa, involucra y conviértete en el experto.',
    trainAmbassador: 'Educa, involucra y conviértete en embajador experto.',
    showroom: '',
    retain:
      '¡Felicitaciones por completar tu entrenamiento! Ahora has desbloqueado tu recurso de referencia para retener tu conocimiento experto y habilitar tus esfuerzos de ventas. Usa esta área para responder expertamente una pregunta sobre el producto o incluso como una presentación de ventas improvisada — en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    retainAmbassador:
      '¡Felicitaciones por completar tu entrenamiento! Ahora has desbloqueado tu recurso de referencia para retener tu conocimiento experto y habilitar tus esfuerzos de ventas. Usa esta área para responder expertamente una pregunta sobre el producto o incluso como una presentación de ventas improvisada — en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote: 'Comparte estos elementos para despertar interés e iniciar una conversación con clientes y prospectos.',
    promoteAmbassador:
      'Aquí encontrarás recursos para mantenerte al día sobre lo esencial del turismo, así como contenidos interesantes para compartir con los visitantes y ayudarles a disfrutar lo mejor del destino.',
    sell: 'Responde preguntas de clientes y cierra la venta como un profesional con recursos profundos y apoyo de ventas dirigido.',
    favorites: 'Revisa tu contenido favorito personal',
    search: 'Busca a través de todo el contenido',
    subapps: 'Obtén una insignia de Especialista al completar estos módulos rápidos de un solo capítulo para socios.',
    subAppsFull: 'Alcance la categoría de experto conociendo a nuestros socios',
    maintrainings: 'Completa estos módulos esenciales para obtener tu certificado.',
    subtrainings: 'Mejora tu juego y gana una insignia por cada capítulo de especialización a continuación.',
    fastTrack: '¡Actualmente estás en el Fast Track. ¡Complétalo para obtener tu calificación!',
  },
  general: {
    chapter: 'Capítulo',
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar Sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se han encontrado resultados para {query}',
    noFavorites: 'Aún no tienes favoritos.',
    noMessages: '¡Aún no has recibido mensajes!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todo',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡404 Página No Encontrada!',
    oops: 'Ups...',
    overview: 'Regresar a la vista general',
    complete: 'Continuar',
    courseComplete: '¡Capítulo Completado!',
    chapterComplete: '¡Capítulo Completado!',
    message: '{count} Mensaje',
    messagePlural: '{count} Mensajes',
    viewBadge: 'Ver',
    downloadBadge: 'Descargar Insignia',
    viewBadge2: 'Insignia',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Colección',
    layout: 'Diseño',
    web: 'Sitio Web',
    pdf: 'PDF',
    carousel: 'Colección',
  },
  questions: {
    dials: 'Gira los diales para que coincidan con la respuesta',
    fitb: 'Llena el/los espacio(s) en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Elige la(s) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el deslizador',
    map: 'Responde la pregunta tocando la ubicación correcta en el mapa',
    dropdown: 'Elegir...',
    true: 'Verdadero',
    false: 'Falso',
    arrangeTheWords:
      'Haz clic en las palabras en el orden correcto para completar la oración y luego haz clic en Enviar:',
    matchTheSentence:
      'Haz clic en una frase de la izquierda y luego en su coincidencia de la derecha. Une todos los pares para completar la pregunta.',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo Electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Rechazar',
    settings: 'Configuración de Privacidad',
    message:
      '¡No nos has dicho nada sobre tus preferencias de privacidad de datos! Está bien, pero nos gustaría ofrecerte la mejor experiencia usando el Compañero de Ventas.',
    disabled: 'Parece que has deshabilitado el uso de cookies.',
    use: 'El {{appName}} requiere el uso de cookies para brindarte la mejor experiencia.',
    details: '¿Para qué se usan las cookies?',
    enable: 'Ve cómo habilitar tus cookies {{here}}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message:
      'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este recurso en tus redes sociales favoritas!',
    download: 'Descargar',
    button: 'Compartir',
  },
  sharing: {
    copyURL: 'Copiar Enlace',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Parece que estás tratando de acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa simplemente visita tu tienda de aplicaciones y busca {appName} o haz clic en uno de los botones a continuación',
    benefits: {
      header: 'Esto te proporcionará:',
      1: 'Aprende, Promociona y Vende Sobre la Marcha',
      2: 'Capacitación Multimedia en Todos los Dispositivos',
      3: 'Certificado de Finalización',
      4: 'Presentaciones de Ventas Listas para Usar',
      5: 'Materiales Promocionales de Alto Impacto',
      6: 'Directorio de Productos en Tiempo Real',
      7: 'Noticias y Actualizaciones Oportunas',
    },
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Cantidad de resultados: ',
    filter: 'Filtrar',
    filters: 'Filtros:',
    subFilter: 'Sub Filtro',
    category: 'Categoría',
    subcategory: 'Subcategoría',
    resetFilters: 'Restablecer Filtros',
    showResults: 'Mostrar Resultados',
    clear: 'Limpiar',
    noResults: 'No se encontraron resultados. Por favor intenta con una búsqueda diferente.',
    resetMap: 'Restablecer Mapa al Inicio >',
    viewNow: 'Ver Ahora >',
  },
  directory: {
    artsentertainment: 'Artes y Entretenimiento',
    conventionservices: 'Servicios de Convenciones',
    divingsnorkeling: 'Buceo y Snorkel',
    film: 'Cine',
    hotels: 'Hoteles',
    lgbtgymsandspas: 'LGBT+: Gimnasios y Spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Dónde Alojarse',
    multiculturaldining: 'Multicultural: Restaurantes',
    multiculturalnightlife: 'Multicultural: Vida Nocturna',
    nightlife: 'Vida Nocturna',
    petfriendly: 'Pet-Friendly',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Spas',
    sports: 'Deportes',
    transportation: 'Transporte',
    venues: 'Lugares',
    waterways: 'Vías Fluviales',
    waystoplay: 'Formas de Jugar',
    weddinglocations: 'Ubicaciones para Bodas',
    weddingvendors: 'Proveedores de Bodas',
    attraction: 'Atracciones',
    cvb: 'CVBs',
    accommodation: 'Alojamientos',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'Soy Un...',
    brandAmbassador: 'Embajador de Marca',
    travelPro: 'Profesional de Viajes',
  },
  rewards: {
    rewards: 'Recompensas',
    title: 'Bienvenido al Centro de Recompensas',
    subheader: 'Rastrea y Comparte Envíos de Reservas y Recompensas',
    titleAmbassador: 'Bienvenido al Centro de Logros',
    subheaderAmbassador:
      'Haz un seguimiento de tus logros de entrenamiento, canjea tus recompensas y comparte tus certificaciones.',
    lockedPopupNotGraduated:
      'Accede a estas ventajas exclusivas para titulados completando la formación y obteniendo tu certificado ',
    button: 'Enviar tu reserva',
    products: 'Mercado',
    viewAllBookings: 'Reservas',
    viewLeaderboard: 'Tabla de Líderes',
    viewDashboard: 'Panel de Puntos',
    viewRewards: 'Vista General',
    home: {
      entries: 'Entradas Actuales',
      trainingAchievements: 'LOGROS DE ENTRENAMIENTO',
      trainingAchievementsText:
        'Rastree su progreso de entrenamiento, certificaciones y el estado de sus recompensas metálicas en esta página. También podrá descargar y compartir su diploma, así como cualquier insignia que haya obtenido.',
      bookingContests: 'PANEL DE RESERVAS',
      bookingContestsText:
        'Rastree y gestione fácilmente las presentaciones de reservas actuales en el Panel de Reservas.',
      submitBooking: 'ENVIAR RESERVAS',
      submitBookingText: 'Aquí es donde enviará las reservas para su inclusión en los concursos de reservas.',
      currentContest: 'CONCURSO ACTUAL',
      currentContests: 'CONCURSOS ACTUALES',
      contestEnterBookings: 'ingresando sus reservas',
      contestNow: ' ¡ahora!',
      contestSeeOther: 'Ver otros ',
      contestTerms: 'Términos y Condiciones',
      noContest: 'El concurso no está disponible actualmente.',
    },
    bookingRewardsView: {
      title: 'Mercado',
    },
    bookingsView: {
      title: 'Reservas',
    },
    leaderboardScreen: {
      title: 'PUNTOS \n Tabla de Líderes',
      earnedpts: 'MIS PUNTOS GANADOS​:',
      pointsWall: 'RASTREADOR TOP 5 DE PUNTOS​:',
      startEarning: '¡Comienza ahora a ganar XP y únete a la tabla de líderes!',
      prizes: 'Premios',
      tAndC: 'Se aplican Términos y Condiciones*',
      pointsOverview: {
        title: 'Cómo ganar puntos',
        booths: 'Visitar Aliados de Expositores',
        breakoutSessions: 'Asistir a Sesiones Grupales y Destacados de Destino',
        trainingSessions: 'Completar un Capítulo de Entrenamiento',
        adventureSpotlights: 'Consejos de Viajes Familiares',
        share: 'Compartir Contenido',
        shareMax: '(hasta {maxSharePoints} puntos)',
        shareInfo:
          'Compartir se cuenta al compartir contenido del stand en X y Facebook o compartir todo el stand con colegas o clientes.',
        viewVideo: 'Ver Video',
      },
    },
    dashboardView: {
      title: 'Panel de Reservas',
      subtitle: 'Rastrea y Gestiona Tus Entradas de Reservas Aquí.',
      badge: 'Insignias',
      activity: 'Panel de Reservas',
      manage: 'Gestionar Reservas',
      manageSub:
        'Ordena usando los botones de arriba y haz clic en cualquier registro para gestionar detalles de envío. Todas las entradas pendientes serán verificadas dentro de 72 horas. ',
      noBookings: 'No hay registros para mostrar.',
      state: {
        approvedEntries: 'Entradas Aprobadas',
        pendingEntries: 'Entradas Pendientes',
        declinedEntries: 'Entradas Rechazadas',
        viewAll: 'Ver Todo',
      },
      columns: {
        wholesaler: 'Mayorista',
        clientLastName: 'Apellido del Cliente',
        totalCostUsd: 'Costo Total USD',
        hotelName: 'Nombre del Hotel',
        hotelConfirmNumber: 'Número de Confirmación del Hotel',
        flightNumber: 'Número de Vuelo',
        typeOfBooking: 'Tipo de Reserva',
        checkIn: 'Check-In',
        checkOut: 'Check-Out',
        status: 'Estado',
      },
    },
    bookingForm: {
      title: 'Formulario de Envío de Reserva',
      subTitle: 'Ingresa tu reserva:',
      required: '* Indica un campo requerido',
      email: 'Correo del Agente',
      agentFirstName: 'Nombre del Agente',
      agentLastName: 'Apellido del Agente',
      company: 'Nombre de la empresa',
      iata: 'IATA/CLIA #',
      stateProvince: 'Estado/Provincia',
      postalCode: 'Código Postal *',
      country: 'País',
      clientLastName: 'Apellido del Cliente',
      confirmationNumber: 'Número de Confirmación del Hotel',
      flightNumber: 'Número de Vuelo',
      hotelName: 'Nombre del Hotel',
      bookingNumber: 'Número de Confirmación de Reserva',
      numberOfGuests: 'Número de Huéspedes Adultos',
      bookingDate: 'Fecha de Reserva',
      tourOperator: 'Operador Turístico / Método de Reserva',
      firstName: 'Nombre',
      lastName: 'Apellido del Huésped',
      guestLastName: 'Apellido del Huésped',
      accommodation: 'Resort/Hotel/Alojamientos reservados',
      select: 'Selecciona una opción',
      wholesaler: 'Nombre del Mayorista (si aplica): si esta es una reserva directa, ingresa NINGUNO',
      arrivalDate: 'Fecha de Check-In',
      departureDate: 'Fecha de Check-Out',
      lengthOfStay: 'Duración de la Estadía (en Noches)',
      totalNights: 'Total de Noches',
      reservationNumber: 'Número de Reserva',
      rooms: 'Número de Habitaciones',
      stay: 'Duración de la Estadía (en Noches)',
      airline: 'Aerolínea / Transportista (código de 2 dígitos)',
      originAirport: 'Portal de Origen (código de aeropuerto de 3 letras)',
      destination: 'Destino/isla (código de aeropuerto de 3 letras)',
      cost: 'Costo Total de la Reserva (usar solo decimales)',
      totalCost: 'Costo Total',
      file: 'Subir Comprobante RezSnap™',
      disclaimer: '* Campos requeridos',
      button: 'Enviar tu reserva',
      sub: 'Tu información',
      sub2: 'Información de reserva',
      guests: 'Número de Pasajeros',
      numberOfPassengers: 'Número de Pasajeros',
      accommodationBooked: 'Resort/Hotel/Alojamientos reservados',
      accommodationCharterCompany: 'Hotel, villa, empresa de alquiler de embarcaciones',
      propertyCharterCompany: 'Inmobiliaria / Empresa de alquiler de embarcaciones',
      typeofBooking: 'Tipo de Reserva',
      dragAndDrop: 'Arrastra y suelta algunos archivos aquí, o haz clic para seleccionar archivos',
      acceptedFiles: 'Solo se aceptarán archivos .jpeg, .png y .pdf. El tamaño máximo del archivo es de 100 MB.',
      missingRequiredFields: 'Por favor completa todos los campos requeridos',
      invalidNumber: 'Debe ser un número mayor que 0.',
    },
    TermsAndConditions: {
      title: 'Términos y Condiciones',
      button: 'Volver',
    },
    thankYouPage: {
      thanks: 'Gracias',
      congrats: 'Felicitaciones, ',
      body: 'tu reserva ha sido recibida y enviada al supervisor de campaña para verificación.',
    },
    menu: {
      home: 'Centro de\nRecompensas',
      homeAmbassador: 'Resumen',
      achievements: 'Logros de\nEntrenamiento',
      bookings: 'Panel de\nReservas',
      form: 'Enviar\nReservas',
    },
  },
  badgeView: {
    title: 'Logros de Capacitación',
    subtitle:
      'Sigue tu progreso de entrenamiento, certificaciones y el estado de tus recompensas metálicas en esta página. También podrás descargar y compartir tu diploma {program_name_short}, así como cualquier insignia que hayas obtenido.',
    badgeDisplayTitle: 'Estado de logro metálico',
    badgeAchievement:
      '¡Has alcanzado el estado {rank}! Haz clic en el icono de la derecha para ver y compartir tu estado.',
    bronze: 'Bronce',
    silver: 'Plata',
    gold: 'Oro',
    platinum: 'Platino',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Insignias de especialización',
    partnerBadges: 'Insignias de Socio',
    tierRewards: 'Recompensas de nivel',
    click: 'Haz clic ',
    here: 'aquí',
    bronzeReward: ' para acceder a tu recompensa exclusiva de BRONCE.',
    silverReward: ' para acceder a tu recompensa exclusiva de PLATA.',
    goldReward: ' para acceder a tu recompensa exclusiva de ORO.',
    bronzeRewardTitle: 'Recompensa de Estado Bronce',
    silverRewardTitle: 'Recompensa de Estado Plata',
    goldRewardTitle: 'Recompensa de Estado Oro',
  },
  badgeDisplay: {
    status: 'Nivel de formación alcanzado',
  },
  tierCard: {
    achieved: 'Logrado',
    modules: 'módulos',
    sales: 'Ventas',
    bookings: 'Reservas',
    or: 'o',
    workingToward: 'Trabajando hacia',
    currentTier: 'Nivel Actual',
    workingTowardBronze: '¡Completa la certificación para alcanzar el estado Bronce!',
    expiresIn: 'Expira en',
    days: 'días',
    expiringToday: '¡Expira hoy!',
    expiryDate: 'Fecha de Expiración',
    nextTier: 'Siguiente Nivel',
    nextGoal: 'Siguiente Meta',
    allTiers: 'Todos los Niveles',
    bronzeDescription: 'Recompensa a asesores que completan lo básico y muestran compromiso inicial.',
    silverDescription: 'Reconoce a asesores que venden consistentemente y permanecen comprometidos.',
    goldDescription: 'Recompensa a los mejores que están profundamente involucrados en las ventas.',
    title: {
      bronze: 'Bronce',
      silver: 'Plata',
      gold: 'Oro',
    },
    requirement: {
      bronze: 'Completa la Certificación de Especialista en Bahamas',
      silver: 'Gana $5,000+ en ventas de viajes a Bahamas o 5+ reservas',
      gold: 'Gana $15,000+ en ventas de viajes a Bahamas o 15+ reservas',
    },
    tierCopy: '¡Felicidades! ¡Has alcanzado el estado {tier}!',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
  categories: {
    all: 'Todo',
    accommodations: {
      accommodations: 'Alojamientos',
      bedbreakfast: 'Bed & Breakfast',
      campgroundsrvparks: 'Campamentos y Parques de RV',
      condo: 'Condominio',
      hotel: 'Hotel',
      vacationrentals: 'Alquileres Vacacionales',
    },
    attractions: 'Atracciones',
    dining: 'Restaurantes',
  },
  preregisterView: {
    comingSoon: 'Próximamente:',
    title: 'El nuevo {appName}',
    success:
      'Te has preinscrito correctamente en el programa. Recibirás un correo electrónico cuando el programa se lance.',
    fillRequired: 'Por favor, completa todos los campos obligatorios: {fields}',
    email: 'Correo electrónico',
    firstName: 'Nombre',
    lastName: 'Apellido',
    agencyName: 'Nombre de la agencia',
    country: 'País',
    selectDefault: 'Por favor, selecciona una opción a continuación',
    requiredFields: '* Campos obligatorios',
    submit: 'Enviar',
    isRegistered:
      'Te has preinscrito correctamente en el programa. Recibirás un correo electrónico cuando el programa se lance.',
    somethingWentWrong: 'Algo ha ido mal. Por favor, inténtalo de nuevo.',
  },
  profileImageView: {
    currentImage: 'Tu imagen de perfil actual:',
    uploadImage: 'Sube tu imagen de perfil:',
    chooseAFile: 'Elige un archivo…',
    cancel: 'Cancelar',
    backButton: 'Volver',
    uploadButton: 'Subir imagen de perfil',
    saveButton: 'Guardar esta imagen de perfil',
    fileTooLargeTitle: 'Se ha superado el tamaño máximo de subida',
    fileTooLargeText: 'El tamaño máximo de subida de imágenes es de 10 MB',
  },
  FastTrackView: {
    incorrectAnswer: 'Eso no es correcto.',
    question: 'Q{current}/{total}',
    questionCounter: '{current} de {total} preguntas',
    score: 'Puntuación: {correct}/{total}',
    nextIn: 'Siguiente en {count}s',
    goToNextQuestion: 'Ir a la siguiente pregunta',
    gradeEarned: 'Calificación obtenida',
    correct: 'Correcto',
    completeFastTrack: 'Completar Fast Track',
    beginFullTraining: 'Comenzar formación completa',
    fastTrackComplete: '¡Fast Track completado!',
    fastTrackNotPassed: 'Fast Track no superado',
    downloadDiploma: 'Descargar diploma',
    resultSuccessMessage: '¡Felicitaciones — ha superado el Fast Track y ha ganado su diploma!',
    resultAchievementsPrefix: ' Puede acceder a su diploma en el área de ',
    resultAchievementsLinkText: 'Logros de Formación',
    resultAchievementsSuffix: '.',
    resultFailureMessage:
      'Lamentablemente, no superó el Fast Track. Está limitado a un intento por usuario — pero ¡aún puede obtener su diploma! Trabaje en la formación completa para ampliar su conocimiento y complétela a su propio ritmo.',
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Conversaciones anteriores',
    showNextSuggestionsAria: 'Mostrar más sugerencias',
    headingAria: 'Abrir TA SmartAssist',
    headingResumeAria: 'Reanudar conversación',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Conversaciones recientes',
    previousConversations: 'Conversaciones anteriores',
    noRecentConversations: 'Sin conversaciones recientes',
    deleteConversationAria: 'Eliminar conversación',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Nueva conversación',
    sourcesFromApp: 'Fuentes',
    loadingConversation: 'Cargando conversación…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'Pensando…',
    messageLimitReached: 'Límite de mensajes alcanzado',
    messageRemaining: '{remaining} mensaje restante',
    messagesRemaining: '{remaining} mensajes restantes',
    quotaBarAria: '{remaining} de {total} mensajes restantes',
    resetsAt: 'Se reinicia el {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'este destino',
    appNotReady: 'La app aún no está configurada.',
    signInRequired: 'Por favor, inicia sesión para continuar.',
    genericError: 'Algo salió mal. Por favor intenta de nuevo.',
    requestFailed: 'Solicitud fallida. Por favor intenta de nuevo.',
    sourceFallback: 'Fuente',
    fallbackSuggestions: {
      bestBeaches: 'Mejores playas',
      familyActivities: 'Actividades en familia',
      hiddenGems: 'Joyas ocultas',
      roadTrips: 'Viajes por carretera',
      dining: 'Mejores restaurantes',
      events: 'Próximos eventos',
    },
    structured: {
      confidenceThreshold: 'Confianza',
      confidenceThresholdPercentAria: 'Confianza: {percent}%',
      recommendation: 'Recomendación',
      alignment: 'Verificación de alineación',
      tailor: 'Para personalizar',
      tips: 'Consejos de eficiencia',
    },
  },
  imageGallery: {
    noticeTitle: 'Aviso de uso de imágenes',
    noticeText: 'Todas las imágenes están licenciadas exclusivamente a {clientName} y no pueden usarse sin permiso',
  },
};
